import { Component, Input } from '@angular/core';
import { KeyValue } from '@app/services/webform.service';
import { formatNumber } from '@app/helpers/webform';

@Component({
  standalone: false,
  selector: 'webform-calc-household-goods',
  templateUrl: './household-goods.component.html',
  styleUrl: './household-goods.component.scss',
})
export class HouseholdGoodsComponent {
  @Input() result!: KeyValue;
  @Input() formId!: string;
  @Input() formData!: KeyValue;
  formatNumber: Function = formatNumber;

  public get contractEnd(): string {
    return '';
  }
}
